<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Garantias Locatícias';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>    
<div class="container">
	<p>Confira os tipos de garantias locatícias disponíveis e a o que é necessário em cada uma delas.</p>
	<hr>
	<div class="box-itens-icon">
		<div class="item">
			<div class="icone">
				<i class="fas fa-credit-card fa-8x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>CREDPAGO</h3>
				<p>Fiança locatícia por cartão de crédito de forma rápida, fácil e sem precisar de fiador. Solicite sua análise de crédito nos informando apenas o seu CPF. </p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-user-shield fa-8x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>Fiador</h3>
				<ul>
					<li>1 (um) fiador com, no mínimo, duas propriedades, quitadas e livres de ônus (trazer matrículas atualizadas dos imóveis), ou</li>
					<li>2 (dois) fiadores, cada um com um imóvel, ambos quitados e livres de ônus (trazer matrículas atualizadas dos imóveis).</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-hands-usd fa-8x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>Seguro Fiança</h3>
				<p>A renda deverá ser de, no mínimo, três vezes o valor do aluguel mais encargos.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-file fa-8x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>Carta Fiança</h3>
				<p>Mediante análise de suas cláusulas.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-money-check-alt fa-8x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>Titulo de capitalização</h3>
				<p>15 vezes o valor do aluguel mais encargos.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-home fa-8x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>Hipoteca/Caução de bem Imóvel</h3>
				<p>Esta garantia consiste no gravame hipotecário do imóvel, enquanto durar a locação, dispensando a apresentação de fiador(es). O imóvel pode ser do próprio locatário, de amigos ou parentes, podendo localizar-se em qualquer local do Brasil.</p>
				<p>Documentos Necessários:</p>
				<ul>
					<li>Matrícula atualizada e certidão de ônus e reipersecutória do imóvel</li>
					<li>Cópia da Carteira de Identidade e CPF do(s) proprietário(s)</li>
					<li>Cópia do comprovante de endereço</li>
				</ul>
			</div>
		</div>
	</div>
	<p>Em caso de dúvidas, entre em <a href="/contato">contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/documentacao-necessaria" class="btn btn-primary">Confira a Documentação para Locação <i class="far fa-arrow-right"></i></a>
	</div>
</div>